import {DefaultRootState, useSelector} from 'react-redux';
import {DependencyList} from 'react';
import {useSort} from './sort';

export function useSortBySelector<TState = DefaultRootState, TSelected = unknown, TField = unknown>(selector: (state: TState) => TSelected[], callbackfn: (item: TSelected) => TField, deps?: DependencyList) {
    const callback = function (s1: TSelected, s2: TSelected) {
        const f1 = callbackfn(s1);
        const f2 = callbackfn(s2);

        if (f1 > f2) {
            return 1;
        } else if (f1 < f2) {
            return -1;
        }

        return 0;
    };

    return useSort(useSelector(selector), callback, deps);
}
